<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { isEmpty } from '@utils';

import { XIcon, XButton } from '@clicksign/excalibur';

import BaseFileUpload from '@components/base/BaseFileUpload.vue';
import LayoutValidation from '@layouts/LayoutValidation.vue';
import CertifyInfo from '@components/CertifyInfo.vue';

const store = useStore();
const { t } = useI18n();

const isResignedDocument = ref(false);
const hasTsa = ref(false);

const baseLocale = computed(() => {
  const baseLocale = 'renewCertificate';

  if (hasTsa.value) return `${baseLocale}.with_tsa`;
  if (isResignedDocument.value) return `${baseLocale}.finished`;

  return `${baseLocale}.default`;
});

const documentFile = computed(() => store.state.fileUpload.document);

function downloadFile() {
  const url = window.URL.createObjectURL(new Blob([documentFile.value.data]));

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', documentFile.value.name);

  document.body.appendChild(link);

  link.click();
}
</script>

<template>
  <LayoutValidation
    :icon="isResignedDocument ? 'check' : 'history'"
    color="var(--color-neutral-700)"
    container-width="100%"
  >
    <template #title>
      {{ t(baseLocale + '.title') }}
    </template>

    <template #description>
      {{ t(baseLocale + '.description') }}
    </template>

    <CertifyInfo
      v-if="!isEmpty(documentFile) && hasTsa"
      :valid-document="documentFile"
    />

    <template #action>
      <BaseFileUpload
        v-if="!isResignedDocument && !hasTsa"
        is-renew
        path="/renew_certificates/resign"
        @document-resigned="isResignedDocument = true"
        @document-with-tsa="hasTsa = true"
      />

      <XButton
        v-else-if="!hasTsa"
        @click="downloadFile()"
      >
        <XIcon
          icon="arrow-down-to-line"
          left
        />
        {{ t('renewCertificate.finished.button') }}
      </XButton>
    </template>
  </LayoutValidation>
</template>

<style lang="scss" module></style>
